(function () {
  var moduleSelector = '.js-tf-cart-addons';
  var deliveryExtraPropertyName = '_Delivery Extra';
  var legacyAddonPropertyName = 'Add On For';
  var deliveryPropertyName = 'Delivery Date';
  var checkoutBlocked = false;
  var activeModal = null;
  var activeModalTrigger = null;

  function propertiesFor(item) {
    return item && item.properties ? item.properties : {};
  }

  function isDeliveryExtra(item) {
    var properties = propertiesFor(item);
    return String(properties[deliveryExtraPropertyName]) === 'true'
      || Boolean(properties[legacyAddonPropertyName]);
  }

  function isEligiblePlan(item, productIds) {
    var productId = String(item.product_id || '');
    return !isDeliveryExtra(item)
      && productIds.indexOf(productId) !== -1;
  }

  function purchaseModeFor(item) {
    return item.selling_plan_allocation ? 'subscription' : 'one-time';
  }

  function setFormProperty(form, name, value) {
    var input = form.querySelector('[data-cart-addon-property="' + name + '"]');
    if (!input) return;
    if (value) {
      input.value = value;
      input.name = 'properties[' + name + ']';
    } else {
      input.value = '';
      input.name = '';
    }
  }

  function prepareForm(form, plan, mode) {
    var properties = propertiesFor(plan);
    setFormProperty(form, deliveryPropertyName, properties[deliveryPropertyName]);

    var sellingPlanInput = form.querySelector('[data-cart-addon-selling-plan]');
    var sellingPlanId = form.dataset.sellingPlanId;
    if (sellingPlanInput) {
      var useSellingPlan = mode === 'subscription' && sellingPlanId;
      sellingPlanInput.value = useSellingPlan ? sellingPlanId : '';
      sellingPlanInput.name = useSellingPlan ? 'selling_plan' : '';
    }
  }

  function showExtrasForMode(module, plans, mode) {
    var plan = plans.find(function (item) {
      return purchaseModeFor(item) === mode;
    });
    if (!plan) return;

    var allowedProductIds = plans.map(function (item) {
      return String(item.product_id);
    });
    var hasVisibleExtras = false;
    module._tfCartAddonPlan = plan;
    module._tfCartAddonMode = mode;

    module.querySelectorAll('.js-tf-cart-addon-form').forEach(function (form) {
      var formParentProductIds = (form.dataset.parentProductIds || '').split(',').filter(Boolean);
      var isAllowed = allowedProductIds.some(function (productId) {
        return formParentProductIds.indexOf(productId) !== -1;
      });
      var supportsMode = mode !== 'subscription' || Boolean(form.dataset.sellingPlanId);
      var isVisible = isAllowed && supportsMode;

      form.hidden = !isVisible;
      if (!isVisible) return;

      hasVisibleExtras = true;
      prepareForm(form, plan, mode);
      var button = form.querySelector('.js-tf-cart-addon-add');
      if (button) button.disabled = false;
    });

    var status = module.querySelector('.js-tf-cart-addons-status');
    if (status) {
      status.textContent = hasVisibleExtras ? '' : 'No extras are available for this delivery type.';
    }
  }

  function setCheckoutBlocked(isBlocked) {
    checkoutBlocked = isBlocked;
    document.querySelectorAll('.js-go-cart-drawer-footer a[href*="/checkout"]').forEach(function (link) {
      link.classList.toggle('is-disabled', isBlocked);
      link.setAttribute('aria-disabled', isBlocked ? 'true' : 'false');
    });
    document.querySelectorAll('form button[name="checkout"]').forEach(function (button) {
      button.disabled = isBlocked;
    });
  }

  function closeModal() {
    if (!activeModal) return;
    activeModal.remove();
    activeModal = null;
    document.body.classList.remove('TF-cart-addon-modal-open');
    if (activeModalTrigger) activeModalTrigger.focus();
    activeModalTrigger = null;
  }

  function openModal(trigger) {
    var form = trigger.closest('.js-tf-cart-addon-form');
    var template = form && form.querySelector('.js-tf-cart-addon-modal-template');
    if (!template || !template.content) return;
    closeModal();
    activeModal = template.content.firstElementChild.cloneNode(true);
    activeModalTrigger = trigger;
    document.body.appendChild(activeModal);
    document.body.classList.add('TF-cart-addon-modal-open');
    var closeButton = activeModal.querySelector('.js-tf-cart-addon-modal-close');
    if (closeButton) closeButton.focus();
  }

  function syncModule(module, cart) {
    var productIds = (module.dataset.parentProductIds || '').split(',').filter(Boolean);
    var plans = cart.items.filter(function (item) {
      return isEligiblePlan(item, productIds);
    });
    var hasDeliveryExtras = cart.items.some(isDeliveryExtra);
    var warning = module.querySelector('.js-tf-cart-addons-warning');
    var track = module.querySelector('.js-tf-cart-addons-track');
    var modeField = module.querySelector('.js-tf-cart-addons-mode-field');
    var select = module.querySelector('.js-tf-cart-addons-mode');

    if (!plans.length) {
      module.hidden = !hasDeliveryExtras;
      module._tfCartAddonPlan = null;
      module._tfCartAddonMode = null;
      if (warning) warning.hidden = !hasDeliveryExtras;
      if (track) track.hidden = true;
      if (modeField) modeField.hidden = true;
      return;
    }

    module.hidden = false;
    if (warning) warning.hidden = true;
    if (track) track.hidden = false;
    var modes = plans.reduce(function (values, plan) {
      var mode = purchaseModeFor(plan);
      if (values.indexOf(mode) === -1) values.push(mode);
      return values;
    }, []);
    var selectedMode = select && modes.indexOf(select.value) !== -1 ? select.value : modes[0];

    if (modeField && select) {
      modeField.hidden = modes.length < 2;
      select.value = selectedMode;
      select.onchange = function () {
        showExtrasForMode(module, plans, select.value);
      };
    }

    showExtrasForMode(module, plans, selectedMode);
  }

  function refreshModules() {
    var modules = document.querySelectorAll(moduleSelector);
    if (!modules.length) return;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var hasEligiblePlan = Array.from(modules).some(function (module) {
          var productIds = (module.dataset.parentProductIds || '').split(',').filter(Boolean);
          return cart.items.some(function (item) {
            return isEligiblePlan(item, productIds);
          });
        });
        setCheckoutBlocked(cart.items.some(isDeliveryExtra) && !hasEligiblePlan);
        modules.forEach(function (module) {
          syncModule(module, cart);
        });
      });
  }

  function init() {
    refreshModules();

    var drawerContent = document.querySelector('.js-go-cart-drawer-content');
    if (drawerContent && 'MutationObserver' in window) {
      new MutationObserver(function () {
        refreshModules();
      }).observe(drawerContent, { childList: true });
    }

    document.addEventListener('click', function (event) {
      var modalTrigger = event.target.closest('.js-tf-cart-addon-open-modal');
      if (modalTrigger) {
        event.preventDefault();
        openModal(modalTrigger);
        return;
      }
      if (event.target.closest('.js-tf-cart-addon-modal-close')
        || event.target.classList.contains('js-tf-cart-addon-modal-backdrop')) {
        closeModal();
        return;
      }

      var button = event.target.closest('.js-tf-cart-addon-add');
      if (!button) return;
      var form = button.closest('.js-tf-cart-addon-form');
      var module = button.closest(moduleSelector);
      if (!form || !module || !module._tfCartAddonPlan || !module._tfCartAddonMode) {
        event.preventDefault();
        return;
      }

      // Stop Go Cart from intercepting — we'll post the request ourselves
      // so we have full control over the selling_plan field.
      event.preventDefault();
      event.stopPropagation();

      var addonTitle = form.dataset.addonTitle || '';
      var status = module.querySelector('.js-tf-cart-addons-status');
      if (status) status.textContent = addonTitle + ' is being added to your delivery.';
      button.disabled = true;

      var plan = module._tfCartAddonPlan;
      var mode = module._tfCartAddonMode;
      var planProperties = propertiesFor(plan);

      var body = {
        id: form.querySelector('[name="id"]').value,
        quantity: parseInt(form.querySelector('[name="quantity"]').value, 10) || 1,
        properties: { '_Delivery Extra': 'true' }
      };

      var deliveryDate = planProperties[deliveryPropertyName];
      if (deliveryDate) body.properties['Delivery Date'] = deliveryDate;

      var menuWeek = planProperties['Menu'];
      if (menuWeek) body.properties['Menu'] = menuWeek;

      if (mode === 'subscription' && form.dataset.sellingPlanId) {
        body.selling_plan = form.dataset.sellingPlanId;
      }


      // Appstle overrides both window.fetch and XMLHttpRequest in the page
      // context, stripping selling_plan when its own widget isn't present.
      // We spawn a Web Worker to make the cart add call from a clean JS scope
      // that Appstle cannot intercept.
      var cartAddUrl = window.location.origin + '/cart/add.js';
      var workerSrc = [
        'self.onmessage = function(e) {',
        '  var payload = e.data.body;',
        '  var url = e.data.url;',
        '  fetch(url, {',
        '    method: "POST",',
        '    credentials: "include",',
        '    headers: { "Content-Type": "application/json" },',
        '    body: JSON.stringify(payload)',
        '  })',
        '  .then(function(r) { return r.json(); })',
        '  .then(function(d) { self.postMessage({ ok: true, data: d }); })',
        '  .catch(function(err) { self.postMessage({ ok: false, error: String(err) }); });',
        '};'
      ].join('\n');
      var blob = new Blob([workerSrc], { type: 'application/javascript' });
      var workerUrl = URL.createObjectURL(blob);
      var worker = new Worker(workerUrl);
      worker.onmessage = function (e) {
        URL.revokeObjectURL(workerUrl);
        var result = e.data;
        if (result.ok) {
          if (status) status.textContent = addonTitle + ' added!';
          button.disabled = false;
          // On the cart page the item list is server-rendered Liquid, so neither
          // __tfRefreshDrawer nor fetchCart() will update it — a page reload is
          // the only reliable way to show the newly added add-on immediately.
          if (window.location.pathname === '/cart') {
            window.location.reload();
          } else if (typeof window.__tfRefreshDrawer === 'function') {
            window.__tfRefreshDrawer();
          } else if (window.__goCartInstance && typeof window.__goCartInstance.fetchCart === 'function') {
            window.__goCartInstance.fetchCart();
          }
        } else {
          if (status) status.textContent = 'Something went wrong. Please try again.';
          button.disabled = false;
          console.error('[TF-addons] Worker error', result.error);
        }
      };
      worker.onerror = function (err) {
        URL.revokeObjectURL(workerUrl);
        if (status) status.textContent = 'Something went wrong. Please try again.';
        button.disabled = false;
        console.error('[TF-addons] Worker failed to start', err);
      };
      worker.postMessage({ body: body, url: cartAddUrl });
    }, true);

    document.addEventListener('click', function (event) {
      var checkoutLink = event.target.closest('.js-go-cart-drawer-footer a[href*="/checkout"]');
      if (!checkoutLink || !checkoutBlocked) return;
      event.preventDefault();
    }, true);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeModal();
    });

    document.addEventListener('submit', function (event) {
      if (!checkoutBlocked || !event.submitter || event.submitter.name !== 'checkout') return;
      event.preventDefault();
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
